export const UI_VERSION: string = import.meta.env.VITE_UI_VERSION ?? "0.1.0";
export const BUILD_SHA: string = (import.meta.env.VITE_BUILD_SHA ?? "local").slice(0, 7);
export const BUILD_ENV: "production" | "staging" | "dev" =
  import.meta.env.VITE_BUILD_ENV === "production" ? "production" : import.meta.env.VITE_BUILD_ENV === "staging" ? "staging" : "dev";
export const DOCS_URL: string | undefined = import.meta.env.VITE_DOCS_URL || undefined;
export const ISSUE_URL: string = import.meta.env.VITE_ISSUE_URL ?? "mailto:ats-support@atatus.com?subject=ATS%20issue";
export const REQUIRED_API_VERSION = "v1";
export const REQUIRED_PROTOCOL = 1;
export const MOCK_MODE: boolean = import.meta.env.VITE_MOCK === "1";
